// extracted by css-extract-rspack-plugin
export default {"cls1":"ChatInterface-cls1_QsQ","cls2":"ChatInterface-cls2_Cbv ChatInterface-cls1_QsQ"};